var cibDropbox = ["32 32", "<path d='M8 2.412l-8 5.093 8 5.093 8-5.093zM24 2.412l-8 5.093 8 5.093 8-5.093zM0 17.697l8 5.1 8-5.1-8-5.093zM24 12.604l-8 5.093 8 5.1 8-5.1zM8 24.495l8 5.093 8-5.093-8-5.093z'/>"];

export { cibDropbox };

